module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DIV', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSpinner),
      expression: "loadingSpinner"
    }],
    staticClass: "content-wrapper",
    attrs: {
      "element-loading-text": "Подождите"
    }
  }, [(_vm.serverData.loadingDataStatus.mainCommonData != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются общие данные\n")]) : (_vm.serverData.loadingDataStatus.events != _vm.serverData.loadingDataStatus.types.LOADED) ? _c('div', {
    staticClass: "loading-text"
  }, [_vm._v("\n  Подождите, загружаются данные по площадкам\n")]) : (_vm.event == null) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button"
  })]), _vm._v(" "), _c('div', {
    staticClass: "eventnotfound-text"
  }, [_vm._v("Событие не найдено")])]) : (_vm.viewType == 2) ? _c('div', {
    staticClass: "select-places"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button",
    staticStyle: {
      "width": "52px",
      "padding-left": "7px"
    },
    on: {
      "click": function($event) {
        _vm.viewType = 1
      }
    }
  }), _vm._v(" "), _c('Input', {
    staticClass: "event-prop",
    staticStyle: {
      "width": "calc(100% - 52px)",
      "padding-right": "25px",
      "float": "right"
    },
    attrs: {
      "placeholder": "Фильтр по названию или адресу",
      "size": "large"
    },
    model: {
      value: (_vm.placesFilterValue),
      callback: function($$v) {
        _vm.placesFilterValue = $$v
      },
      expression: "placesFilterValue"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.filteredPlaces), function(place, key) {
    return _c('div', {
      key: place.val.id,
      staticClass: "select-place",
      on: {
        "click": function($event) {
          _vm.event.val.place = place.val.id;
          _vm.viewType = 1
        }
      }
    }, [_c('div', {
      staticClass: "select-place-image",
      style: ({
        'background-image': 'url(' + _vm.serverData.imagesGetURL(place.val.images[0]) + ')'
      })
    }, [_vm._v("\n       \n    ")]), _vm._v(" "), _c('DIV', {
      staticClass: "select-place-info"
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "padding": "0px 0 0 0",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "select-place-name"
    }, [_vm._v(_vm._s(place.val.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "padding": "10px 0 0 0",
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "select-place-prop",
      staticStyle: {
        "padding-top": "3px"
      }
    }, [_vm._v(_vm._s(place.val.city) + ", " + _vm._s(place.val.address))])])])], 1)
  })], 2) : (_vm.viewType == 1) ? _c('div', {
    staticClass: "event"
  }, [_c('div', {
    staticClass: "event-image",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.event.val.body.images[0]) + ')'
    }),
    attrs: {
      "id": "eventimage1"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left back-button-over",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-edit back-button-over-center",
    on: {
      "click": function($event) {
        _vm.$refs.uploadingFileRef1.click()
      }
    }
  }), _vm._v(" "), _c('input', {
    ref: "uploadingFileRef1",
    staticClass: "input_file_hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.uploadingFileOnChange(1)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "float": "left"
    }
  }, [(_vm.event.val.status != 1) ? _c('div', {
    staticClass: "event-status",
    style: ({
      'background': _vm.getEventStatusBackground()
    })
  }, [_vm._v("\n      " + _vm._s(_vm.getEventStatusText())), _c('br'), _vm._v("по причине: " + _vm._s(_vm.event.val.body.cancelReason) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('DIV', {
    staticClass: "event-props-block"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "10px 0 0 0",
      "text-align": "left",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title"
  }, [_vm._v("Автор")]), _vm._v(" "), _c('div', {
    staticClass: "event-prop link",
    on: {
      "click": function($event) {
        _vm.goToUserCard(_vm.event.val.createdBy)
      }
    }
  }, [_c('div', {
    staticClass: "event-prop-user-avatar",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.serverData.usersMap[_vm.event.val.createdBy].body.avatar) + ')'
    })
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100% - 44px)",
      "padding-top": "10px",
      "float": "right"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.serverData.usersMap[_vm.event.val.createdBy].name)), _c('br')])])]), _vm._v(" "), (_vm.isActiveUserAdmin()) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0 0 0 0",
      "text-align": "left",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title"
  }, [_vm._v("Изменил")]), _vm._v(" "), _c('div', {
    staticClass: "event-prop link",
    on: {
      "click": function($event) {
        _vm.goToUserCard(_vm.event.val.updatedBy)
      }
    }
  }, [_c('div', {
    staticClass: "event-prop-user-avatar",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.serverData.usersMap[_vm.event.val.updatedBy].body.avatar) + ')'
    })
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100% - 44px)",
      "padding-top": "10px",
      "float": "right"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.serverData.usersMap[_vm.event.val.updatedBy].name)), _c('br')])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title"
  }, [_vm._v("Название")]), _vm._v(" "), _c('Input', {
    staticClass: "event-prop",
    attrs: {
      "placeholder": "Название",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.name),
      callback: function($$v) {
        _vm.event.val.name = $$v
      },
      expression: "event.val.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title"
  }, [_vm._v("Тэги")]), _vm._v(" "), _c('Input', {
    staticClass: "event-prop",
    attrs: {
      "placeholder": "Тэги",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.tags),
      callback: function($$v) {
        _vm.event.val.tags = $$v
      },
      expression: "event.val.tags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title"
  }, [_vm._v("Уровень")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "event-prop event-prop-inputnumber",
    attrs: {
      "min": 1,
      "max": 5,
      "placeholder": "Уровень",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.level),
      callback: function($$v) {
        _vm.event.val.level = $$v
      },
      expression: "event.val.level"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title"
  }, [_vm._v("Цена")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "event-prop event-prop-inputnumber",
    attrs: {
      "min": 0,
      "placeholder": "Цена",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.price),
      callback: function($$v) {
        _vm.event.val.price = $$v
      },
      expression: "event.val.price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "left",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title"
  }, [_vm._v("Место")]), _vm._v(" "), (_vm.event.val.place != null) ? _c('div', {
    staticClass: "event-prop event-prop-place",
    on: {
      "click": function($event) {
        _vm.viewType = 2
      }
    }
  }, [_c('div', {
    staticClass: "event-prop-place-image",
    style: ({
      'background-image': 'url(' + _vm.serverData.imagesGetURL(_vm.serverData.placesMap[_vm.event.val.place].val.images[0]) + ')'
    })
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "calc(100% - 35px)",
      "padding-top": "8px",
      "float": "right"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.serverData.placesMap[_vm.event.val.place].val.name) + "\n      ")])]) : _c('div', {
    staticClass: "event-prop event-prop-place",
    on: {
      "click": function($event) {
        _vm.viewType = 2
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding-top": "8px",
      "color": "#bbb",
      "float": "right"
    }
  }, [_vm._v("Место события")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title"
  }, [_vm._v("Дата старта")]), _vm._v(" "), _c('DatePicker', {
    staticClass: "event-prop",
    attrs: {
      "type": "date",
      "placeholder": "Дата старта",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.dateStart),
      callback: function($$v) {
        _vm.event.val.dateStart = $$v
      },
      expression: "event.val.dateStart"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title"
  }, [_vm._v("Время старта")]), _vm._v(" "), _c('Input', {
    staticClass: "event-prop",
    attrs: {
      "format": "HH:mm",
      "steps": [1, 15],
      "placeholder": "Время окончания",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.timeStart),
      callback: function($$v) {
        _vm.event.val.timeStart = $$v
      },
      expression: "event.val.timeStart"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title-doubleline"
  }, [_vm._v("Дата"), _c('br'), _vm._v("окончания")]), _vm._v(" "), _c('DatePicker', {
    staticClass: "event-prop",
    attrs: {
      "type": "date",
      "placeholder": "Дата старта",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.dateEnd),
      callback: function($$v) {
        _vm.event.val.dateEnd = $$v
      },
      expression: "event.val.dateEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title-doubleline"
  }, [_vm._v("Время"), _c('br'), _vm._v("окончания")]), _vm._v(" "), _c('Input', {
    staticClass: "event-prop",
    attrs: {
      "format": "HH:mm",
      "steps": [1, 15],
      "placeholder": "Время окончания",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.timeEnd),
      callback: function($$v) {
        _vm.event.val.timeEnd = $$v
      },
      expression: "event.val.timeEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title-doubleline"
  }, [_vm._v("Минимум участников")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "event-prop event-prop-inputnumber",
    attrs: {
      "min": 1,
      "placeholder": "Мин кол-во участников",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.body.membersLimitFrom),
      callback: function($$v) {
        _vm.event.val.body.membersLimitFrom = $$v
      },
      expression: "event.val.body.membersLimitFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title-doubleline"
  }, [_vm._v("Максимум участников")]), _vm._v(" "), _c('InputNumber', {
    staticClass: "event-prop event-prop-inputnumber",
    attrs: {
      "min": 1,
      "placeholder": "Макс кол-во участников",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.body.membersLimitTo),
      callback: function($$v) {
        _vm.event.val.body.membersLimitTo = $$v
      },
      expression: "event.val.body.membersLimitTo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title-doubleline"
  }, [_vm._v("Ограничения"), _c('br'), _vm._v("для участников")]), _vm._v(" "), _c('Input', {
    staticClass: "event-prop",
    attrs: {
      "placeholder": "Ограничения для участников",
      "size": "large"
    },
    model: {
      value: (_vm.event.val.body.membersLimits),
      callback: function($$v) {
        _vm.event.val.body.membersLimits = $$v
      },
      expression: "event.val.body.membersLimits"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "event-prop-title"
  }, [_vm._v("Описание")]), _vm._v(" "), _c('Input', {
    staticClass: "event-prop",
    attrs: {
      "placeholder": "Описание",
      "size": "large",
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.event.val.description),
      callback: function($$v) {
        _vm.event.val.description = $$v
      },
      expression: "event.val.description"
    }
  })], 1), _vm._v(" "), (_vm.event.val.status != _vm.eventStatuses.BANNED_BY_ADMIN) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "0px",
      "float": "left"
    }
  }, [_c('Button', {
    staticClass: "button button-primary",
    staticStyle: {
      "width": "calc((100% - 10px - 4px) / 2)",
      "margin": "30px 0 0 0"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.saveAndClose()
      }
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('Button', {
    staticClass: "button",
    staticStyle: {
      "width": "calc((100% - 10px - 4px) / 2)",
      "margin": "30px 0 0 10px"
    },
    attrs: {
      "type": "ghost",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("Не сохранять")])], 1) : _vm._e(), _vm._v(" "), (_vm.event.val.id != null) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }, [_c('hr', {
    staticStyle: {
      "width": "100%",
      "float": "left"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "event-prop-title",
    staticStyle: {
      "width": "130px",
      "padding": "6px 5px 0 0px",
      "font-size": "14px",
      "color": "#bbb",
      "float": "left"
    }
  }, [_vm._v("Причина снятия"), _c('br'), _vm._v("с публикации")]), _vm._v(" "), _c('Input', {
    staticClass: "event-prop",
    staticStyle: {
      "width": "calc(100% - 130px)",
      "margin-top": "2px",
      "font-size": "14px",
      "float": "left"
    },
    attrs: {
      "placeholder": "Причина снятия с публикации",
      "size": "large",
      "disabled": (_vm.event.val.status != _vm.eventStatuses.ACTIVE) && (_vm.isActiveUserAdmin() == false)
    },
    model: {
      value: (_vm.event.val.body.cancelReason),
      callback: function($$v) {
        _vm.event.val.body.cancelReason = $$v
      },
      expression: "event.val.body.cancelReason"
    }
  }), _vm._v(" "), (_vm.event.val.status == _vm.eventStatuses.ACTIVE) ? _c('Button', {
    staticClass: "button",
    staticStyle: {
      "width": "200px",
      "margin": "10px 0 0 0",
      "color": "#bbb",
      "float": "right"
    },
    attrs: {
      "type": "ghost",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.changeStatus('cancel')
      }
    }
  }, [_vm._v("Снять с публикации")]) : _vm._e(), _vm._v(" "), (((_vm.event.val.status == _vm.eventStatuses.CANCELLED_BY_ORG) || (_vm.event.val.status == _vm.eventStatuses.CANCELLED_BY_ADMIN)) && (_vm.event.val.createdBy == _vm.activeUser.id)) ? _c('Button', {
    staticClass: "button",
    staticStyle: {
      "width": "200px",
      "margin": "10px 0 0 0",
      "color": "#fff",
      "background": "#db3",
      "float": "right"
    },
    attrs: {
      "type": "ghost",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.changeStatus('activate')
      }
    }
  }, [_vm._v("Опубликовать")]) : _vm._e(), _vm._v(" "), ((_vm.activeUser.id != _vm.event.val.createdBy) && _vm.isActiveUserAdmin() && (_vm.event.val.status != _vm.eventStatuses.BANNED_BY_ADMIN)) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px",
      "float": "left"
    }
  }, [_c('Button', {
    staticClass: "button",
    staticStyle: {
      "width": "200px",
      "margin": "0",
      "background": "#f66",
      "color": "#ddd",
      "float": "right"
    },
    attrs: {
      "type": "ghost",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.changeStatus('ban')
      }
    }
  }, [_vm._v("Забанить событие")])], 1) : _vm._e(), _vm._v(" "), ((_vm.activeUser.id != _vm.event.val.createdBy) && _vm.isActiveUserAdmin() && (_vm.event.val.status == _vm.eventStatuses.BANNED_BY_ADMIN)) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px",
      "float": "left"
    }
  }, [_c('Button', {
    staticClass: "button",
    staticStyle: {
      "width": "200px",
      "margin": "0",
      "background": "#f66",
      "color": "#ddd",
      "float": "right"
    },
    attrs: {
      "type": "ghost",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.changeStatus('remove ban')
      }
    }
  }, [_vm._v("Снять бан")])], 1) : _vm._e()], 1) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cd0704e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EventEdit.vue
// module id = 362
// module chunks = 0